module.exports = __webpack_public_path__ + "assets/img/test4.5cad0463.svg";